import styled from 'styled-components'
import { Card } from 'antd'


export const StyledCard = styled(Card)`
  .text {
    margin: 50px 0;
    font-size: 20px;
    padding: 0px 25%;
  }
  .ant-card {
      background: #0076bf;
      color: #fff;
      font-size: 17px;
      text-align: center;
      cursor: pointer;
      a {
        color: #fff;
      }
      &:hover {
        background: #71bf47;
      }
  }
  .mtb-50 {
    margin: 50px 0;
  }
`



// WEBPACK FOOTER //
// ./src/components/Home/style.js